/** Finadeck's default chart colors, used when a company has no palette of its own. */
export const DEFAULT_CHART_COLORS = [
  '#0225A1',
  '#408C96',
  '#F6B847',
  '#EA4749',
  '#2E5266',
  '#C5C5C5',
  '#F4B895',
  '#ED7C7C',
  '#80A1D4',
  '#74C7C7',
  '#124D87',
  '#F5E6A2'
]

export const isDefaultChartPalette = (colors: string[]) =>
  colors.length === DEFAULT_CHART_COLORS.length &&
  colors.every((color, i) => color.toUpperCase() === DEFAULT_CHART_COLORS[i])

/** A company without colors of its own has no (or an empty) list, which means the default colors. */
export const resolveChartColors = (colors?: string[] | null) => (colors?.length ? colors : DEFAULT_CHART_COLORS)
